import { ApplicationStatusTypeIds, ProductIds } from "@/config/constants";

export interface TimelineMilestone {
  step: number;
  status: string;
  title: string;
  description: string | null;
  html: string | null;
}

type TimelineMilestoneComponent =
  | "Cancelled"
  | "Complete"
  | "COMPLETE"
  | "EvaluationQueue"
  | "NotSubmitted";

export interface TimelineMilestone {
  id: number;
  order: number;
  step: number;
  status: string;
  title: string;
  description: string | null;
	descriptionHtml?: string | null;
  html: string | null;
  visible?: boolean;
  isActive?: boolean;
  component?: TimelineMilestoneComponent | null;
}

export enum TimelineMilestoneIds {
  NOT_YET_SUBMITTED,
  APPLICATION_UNDER_REVIEW,
  APPLICATION_DECLINED,
  APPLICATION_CANCELLED,
  CREDIT_APPROVED,
  DOCUMENTS_AND_VERIFICATION,
  FINAL_DOCUMENTATION,
  SCHOOL_CERTIFICATION,
  DOCUMENTS_AND_PAYOFF_VERIFICATION, // Only for Refi
  RIGHT_TO_CANCEL_PERIOD, // Only for PEL and REFI
  FUNDS_DISBURSED, // Only for PEL
	PAYOFF_SENT_TO_SERVICER,
}

export enum TimelineMilestoneStatus {
  COMPLETE = "complete",
  ACTIVE = "active",
  INCOMPLETE = "",
  ALERT = "alert",
  PENDING = "pending",
}

// Type representing a union of the enum keys: 'Key1' | 'Key2' | 'Key3'
type TimelineMilestoneKeys = keyof typeof TimelineMilestoneIds;
type Products = keyof typeof ProductIds;

export enum TimelineMilestoneTitles {
  APPLICATION_UNDER_REVIEW = "APPLICATION_UNDER_REVIEW",
  NOT_YET_SUBMITTED = "Not Yet Submitted",
  CREDIT_APPROVED = "CREDIT_APPROVED",
  DOCUMENTS_VERIFICATION = "DOCUMENTS_VERIFICATION",
  DOCUMENTS_AND_PAYOFF_VERIFICATION = "DOCUMENTS_AND_PAYOFF_VERIFICATION",
  FINAL_DOCUMENTATION = "FINAL_DOCUMENTATION",
  SCHOOL_CERTIFICATION = "SCHOOL_CERTIFICATION",
	PAYOFF_SENT_TO_SERVICER = "PAYOFF_SENT_TO_SERVICER"
}
type TimelineMilestoneStepTitle =
  | "Application Under Review"
  | "Application Declined"
  | "Application Cancelled"
  | "Not Yet Submitted"
  | "Credit Approved"
  | "Documents & Verification"
  | "Documents & Payoff Verification" // Only for Refi
  | "Final Documentation"
  | "School Certification"
  | "Right To Cancel Period" // only for PEL
  | "Funds Disbursed" // only for PEL
	| "Payoff Sent to Your Servicer"; // Only for Refi

export const productDictionary: Readonly<Record<number, string>> = {
  [ProductIds.LOC]: "LOC",
  [ProductIds.REFI]: "REFI",
  [ProductIds.PEL]: "PEL",
};

export const titleDictionary: Readonly<Record<number, TimelineMilestoneStepTitle>> = {
  [TimelineMilestoneIds.NOT_YET_SUBMITTED]: "Not Yet Submitted",
  [TimelineMilestoneIds.CREDIT_APPROVED]: "Credit Approved",
  [TimelineMilestoneIds.DOCUMENTS_AND_VERIFICATION]: "Documents & Verification",
  [TimelineMilestoneIds.DOCUMENTS_AND_PAYOFF_VERIFICATION]: "Documents & Payoff Verification",
  [TimelineMilestoneIds.FINAL_DOCUMENTATION]: "Final Documentation",
  [TimelineMilestoneIds.SCHOOL_CERTIFICATION]: "School Certification",
  [TimelineMilestoneIds.RIGHT_TO_CANCEL_PERIOD]: "Right To Cancel Period",
  [TimelineMilestoneIds.FUNDS_DISBURSED]: "Funds Disbursed",
  [TimelineMilestoneIds.APPLICATION_UNDER_REVIEW]: "Application Under Review",
  [TimelineMilestoneIds.APPLICATION_DECLINED]: "Application Declined",
  [TimelineMilestoneIds.APPLICATION_CANCELLED]: "Application Cancelled",
	[TimelineMilestoneIds.PAYOFF_SENT_TO_SERVICER]: "Payoff Sent to Your Servicer"
};

export const stepToStatus: Readonly<Record<number, number>> = {
  [TimelineMilestoneIds.NOT_YET_SUBMITTED]: ApplicationStatusTypeIds.NOT_SUBMITTED,
  [TimelineMilestoneIds.CREDIT_APPROVED]: ApplicationStatusTypeIds.SUBMITTED_AND_PROCESSING,
  [TimelineMilestoneIds.DOCUMENTS_AND_VERIFICATION]:
    ApplicationStatusTypeIds.SUBMITTED_AND_PROCESSING,
  [TimelineMilestoneIds.DOCUMENTS_AND_PAYOFF_VERIFICATION]:
    ApplicationStatusTypeIds.SUBMITTED_AND_PROCESSING,
  [TimelineMilestoneIds.FINAL_DOCUMENTATION]: ApplicationStatusTypeIds.SUBMITTED_AND_PROCESSING,
  [TimelineMilestoneIds.SCHOOL_CERTIFICATION]: ApplicationStatusTypeIds.SCHOOL_CERTIFICATION,
  [TimelineMilestoneIds.RIGHT_TO_CANCEL_PERIOD]: ApplicationStatusTypeIds.RIGHT_TO_CANCEL,
  [TimelineMilestoneIds.FUNDS_DISBURSED]: ApplicationStatusTypeIds.COMPLETE,
};
